import React from 'react';
import colors from '../colors';

const Dot = ({ color = colors['flexi-grey'], width = 10 }) => {
  return (
    <div
      // eslint-disable-next-line no-restricted-syntax
      style={{
        width: `${width}px`,
        height: `${width}px`,
        borderRadius: '50%',
        backgroundColor: color,
        transform: `translateY(${width !== 10 ? -2 : 0}px)`
      }}
    />
  );
};

export default Dot;
